import { Button, Container, Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import LayoutWithPageLoading from 'Components/layout/LayoutWithPageLoading';
import DefinitionCard from 'Features/Definitions/DefinitionCard';
import useAsyncTask from 'hooks/useAsyncTask';
import { DefinitionsModel } from 'Models/Definitions';
import { DefinitionState } from 'Models/Definitions/@types';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxStore } from 'stores';
import { TDispatch } from 'Typings/Global';

type StoreSelection = Pick<DefinitionState, 'list'>;

export interface DefinitionsListProps { }

const DefinitionsList: FC<DefinitionsListProps> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();

    const { list } = useSelector<ReduxStore, StoreSelection>(({ Definitions: { list } }) => ({ list }));

    const getDataTask = useAsyncTask(async () => await dispatch(DefinitionsModel.getItemsList({filter:{order: 'created DESC'}})));

    const handleAdd = () => dispatch(DefinitionsModel.showDefinitionForm({}));

    useEffect(() => {
        getDataTask.run();
        //eslint-disable-next-line
    }, []);

    return (
        <LayoutWithPageLoading loading={getDataTask.status === "PROCESSING"} >
            <Button size={'large'} variant={'contained'} onClick={handleAdd} color="primary" className={classes.addButton} >Add New</Button>
            <Container className={classes.root} >
                <Grid container spacing={3} >
                    {
                        list.map((definition) => {
                            return (
                                <Grid item key={definition.id} >
                                    <DefinitionCard definition={definition} />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Container>
        </LayoutWithPageLoading>
    )
}

const useStyles = makeStyles<Theme>((theme) => {
    return (createStyles({
        addButton: {
            position: 'fixed',
            right: 24, top: 64 + 24
        },
        root: {
            paddingTop: 64
        }
    }))
})

export default DefinitionsList